import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "./ui/sheet";
import { OndaAvatar } from "./OndaAvatar";
import { VerifiedBadge } from "./VerifiedBadge";
import { Users } from "lucide-react";

export function GroupMembersSheet({ conv, currentUserId }) {
  const members = conv?.members || [];
  return (
    <Sheet>
      <SheetTrigger asChild>
        <button
          type="button"
          className="q-chip cursor-pointer hover:border-[color:var(--accent)]"
          data-testid="group-members-open"
        >
          <Users size={12} /> {members.length} miembros
        </button>
      </SheetTrigger>
      <SheetContent
        side="right"
        className="border-white/10 bg-[#0f172a]/95 backdrop-blur-2xl text-slate-100 w-[92vw] sm:w-96"
        data-testid="group-members-sheet"
      >
        <SheetHeader>
          <SheetTitle className="font-display">{conv?.title || "Grupo"}</SheetTitle>
          <SheetDescription className="text-slate-400 text-xs">
            {members.length} miembros
          </SheetDescription>
        </SheetHeader>
        <ul className="mt-4 divide-y divide-white/5" data-testid="group-members-list">
          {members.map((m) => (
            <li
              key={m.id}
              className="flex items-center gap-3 py-3"
              data-testid={`group-member-${m.ondatag}`}
            >
              <OndaAvatar src={m.avatar} name={m.display_name} size={40} />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-slate-100 truncate flex items-center gap-1">
                  {m.display_name}
                  {m.is_verified_business && <VerifiedBadge size={13} />}
                  {m.id === currentUserId && (
                    <span className="q-chip !py-0 !px-1.5 !text-[10px]">Tú</span>
                  )}
                </div>
                <div className="font-mono text-xs text-slate-400 truncate">
                  @{m.ondatag}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </SheetContent>
    </Sheet>
  );
}
